import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';

export class RestClient {

	serverUrl: string;
	
	constructor(public http:HttpClient) {
		this.serverUrl = environment.serverUrl;
	}

	
	getParams(qparams:any){
		let params = {};
		let keys = Object.keys(qparams);
		for(let i = 0;i < keys.length;i++){
			params[keys[i]] = qparams[keys[i]];
      	}
       	return params;
	}
	
	getHeaders():any{
		let user = JSON.parse(localStorage.getItem('user'));
		
		var reqHeader = new HttpHeaders({ 
			'Content-Type': 'application/json',
			'Authorization':'Bearer ' + user.access_token
		});
		return reqHeader;

	}
	
	getHeaderMultipart():any{
		let user = JSON.parse(localStorage.getItem('user'));
		
		var reqHeader = new HttpHeaders({ 
		//	'Content-Type': 'multipart/form-data;',
			'Authorization':'Bearer ' + user.access_token
		});
		return reqHeader;

	}
}
